const host = process.env.REACT_APP_BACKEND_URL || "http://localhost:1337";
const eurecatHost = "https://84.88.76.18/wot";

export const weatherApiKey = "c45d67942b6f42a4ac3123410240807";
export const customTokenKey =
  process.env.REACT_APP_CUSTOM_TOKEN_KEY ||
  "46259045d7793427c055cd20645c47777d6177e78a80f325ad1789a186f703094d506de232074244e5a7c2c2473154c65d7310ca99689f3abba18aa1ac36e9785797ae9df8bb10da2fde6b97ea57bd3bb7412264f61bb80abdcd8cddba900339249c3e2e9a6ea7b886e47200d8d4f69c72a243a3e6887364864f6b84f717e9c3";

const api_root = "/api";
export const API_URL_LOGIN = `${host}${api_root}/auth/local`;
export const API_GET_ME = `${host}${api_root}/users/me`;
export const API_WATER_AUTHORITY = `${host}${api_root}/water-authorities`;
export const API_WATER_SYSTEMS = `${host}${api_root}/water-systems`;
export const API_GET_FIELDS_DATA = `${host}${api_root}/fieldsFromFarm`;
export const API_ADD_FIELD_DATA = `${host}${api_root}/fields`;
export const API_UPDATE_FIELD_DATA = `${host}${api_root}/fields`;
export const API_POPULATE_ALL = `?populate=*`;
export const API_SENSORS = `${host}${api_root}/sensors`;
export const API_WEATHER_DATA = `${host}${api_root}/get-weather-data`;
export const API_SENSOR_MEASURE_DATA = `${host}${api_root}/get-measures-by-time-range`;
export const API_ALL_SENSORS_MEASURE = `${host}${api_root}/get-all-sensors-measure`;
export const API_DATA_FROM_MODEL = `${host}${api_root}/get-water-models-data`;
export const API_SIGNUP = `${host}${api_root}/auth/local/register`;
export const API_GET_USERS = `${host}${api_root}/users`;
export const API_FORGOT_PASSWORD = `${host}${api_root}/auth/forgot-password`;
export const API_RESET_PASSWORD = `${host}${api_root}/auth/reset-password`;
export const API_GET_DATASTREAMS_LIST = `${host}${api_root}/get-datastreams-list`;
export const API_GET_DATASTREAM_AGGREGATE_MEASURE = `${host}${api_root}/get-datastream-aggregate-measure`;
export const API_EURECAT = `${eurecatHost}`;
